export default __webpack_public_path__ + "scene1_3_icon570e7b.png";